import React from "react";
import { Link } from "react-router-dom";
import { LogIn, ShieldCheck, MapPin, Zap } from "lucide-react";
import { HexLogo } from "@/components/dashboard/Hex";
import { BrutalButton } from "@/components/dashboard/BentoCard";

export const LOGIN = {
  root: "login-page",
  googleBtn: "login-google-btn",
};

export default function LoginPage() {
  const startGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
    // THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href =
      "https://auth.emergentagent.com/?redirect=" + encodeURIComponent(redirectUrl);
  };

  return (
    <div
      data-testid={LOGIN.root}
      className="min-h-screen flex items-center justify-center bg-honeycomb px-4 py-12"
    >
      <div className="max-w-lg w-full bg-white border-2 border-black shadow-brutal p-10">
        <div className="flex items-center gap-3 mb-8">
          <HexLogo size={52} />
          <div>
            <div className="font-brand text-2xl leading-none text-red-600">
              LIEN SCOUT
            </div>
            <div className="font-mono-data text-[10px] uppercase tracking-widest text-zinc-500 mt-1">
              AI-Powered Property Intelligence
            </div>
          </div>
        </div>

        <h1 className="font-display text-3xl font-bold tracking-tight">
          Track current &amp; upcoming delinquent tax properties nationwide.
        </h1>
        <p className="text-sm text-zinc-600 mt-3">
          Sign in with Google to unlock the full ledger. First 3 days are on us.
        </p>

        <BrutalButton
          data-testid={LOGIN.googleBtn}
          onClick={startGoogle}
          className="mt-8 w-full justify-center py-3 text-base"
        >
          <LogIn size={18} />
          Continue with Google
        </BrutalButton>

        <div className="mt-8 space-y-3 text-sm">
          <FeatureLine icon={ShieldCheck} text="No credit card required to explore" />
          <FeatureLine icon={MapPin} text="Filter by state and the top 5 cities in each state" />
          <FeatureLine icon={Zap} text="Auto-refreshes every 30 minutes" />
        </div>

        <p className="mt-8 text-xs text-zinc-500">
          Have an account already?{" "}
          <Link to="/" className="underline decoration-yellow-500 decoration-2 underline-offset-2">
            Continue to the dashboard
          </Link>
        </p>
      </div>
    </div>
  );
}

function FeatureLine({ icon: Icon, text }) {
  return (
    <div className="flex items-start gap-2">
      <Icon size={16} className="text-yellow-600 mt-0.5" strokeWidth={2.5} />
      <span className="text-zinc-700">{text}</span>
    </div>
  );
}
